import './App.css';
import './Builder'
import CatchAllRoute from './Builder';

function App() {
  return (
    <>
    <CatchAllRoute/>
    </>
    
  );
}

export default App;
